import React from 'react'
import { Divider, List } from 'antd'
import { Offer } from 'src/core/models'
import { useTranslation } from 'next-i18next'
import { useAppDispatch, useAppSelector } from 'src/app/hooks'
import { expireOffer, userAuthenticatedState } from 'src/features'
import { getFormatedPrice, getHumanizeDate, getOfferStatus } from 'src/core/helpers'
import { CustomModal, OffsetDetailsButtonsContent, CustomText } from 'src/components'

interface OfferDetailsModalProps {
  isModalVisible: boolean
  handleCancel: () => void
  offer: Offer
}

const OfferDetailsModal: React.FC<OfferDetailsModalProps> = (props) => {
  const { t } = useTranslation()
  const { isModalVisible, handleCancel, offer } = props
  const user = useAppSelector(userAuthenticatedState)
  const dispatch = useAppDispatch()

  const getTitle = () => {
    const youTitle = t('Offers.YouMadeOffer')
    const otherPersonTitle = t('Offers.OtherMadeOffer', { name: offer.sender_name })
    const dateString = getHumanizeDate(offer.date)
    return offer.sender === user?.id ? `${youTitle} - ${dateString}` : `${otherPersonTitle} - ${dateString}`
  }

  const getOfferTotal = () => {
    const total = offer.amount * offer.price
    return getFormatedPrice(total, offer.currency)
  }

  const handleExpireOffer = (o: Offer) => dispatch(expireOffer(o.id))
  const offerLabels = [
    {
      label1: t('Offers.Project'),
      label2: offer.vintage_year ? `${offer.project_name} - ${offer.vintage_year}` : offer.project_name,
      show: true
    },
    { label1: t('Offers.Price'), label2: offer.price, show: true },
    { label1: t('Offers.Amount'), label2: `${offer.amount} tCO₂`, show: true },
    { label1: t('Offers.OfferTotal'), label2: getOfferTotal(), show: true },
    { label1: t('Offers.Expiration'), label2: getOfferStatus(offer, handleExpireOffer), show: offer.state === 'active' },
    { label1: t('Offers.Message'), label2: offer.content, show: offer.content !== '_' },
    { label1: t('Offers.Offset'), label2: offer.presentedTo, show: !['', undefined, null].includes(offer.presentedTo) },
    { label1: t('Offers.Reason'), label2: offer.offset_reason_content, show: true },
  ]

  return <CustomModal
    title={getTitle()}
    footer={null}
    open={isModalVisible}
    onCancel={() => handleCancel()}
  >
    <List dataSource={offerLabels}
      renderItem={item => {
        if (!item.show) return
        return (
          <List.Item>
            <React.Fragment>
              <CustomText label={t(item.label1)} type='secondary' />
              <CustomText label={item.label2} type={null} />
            </React.Fragment>
          </List.Item>
        )
      }}
    />
    <Divider />
    <OffsetDetailsButtonsContent
      offer={offer}
      handleClose={() => handleCancel()}
    />
  </CustomModal>
}
export default OfferDetailsModal
